module.exports = __webpack_public_path__ + "img/code.e7535e5d.jpg";